import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card } from '@/components/ui/card';

const Terms = () => {
  const { language } = useLanguage();

  return (
    <div className={`min-h-screen bg-adalat-gradient ${language === 'ur' ? 'font-urdu' : 'font-english'}`}>
      <div className="container mx-auto py-8 px-4">
        <div className="flex justify-between items-center mb-8">
          <Header />
          <LanguageSwitcher />
        </div>

        <main className={`max-w-4xl mx-auto ${language === 'ur' ? 'rtl' : 'ltr'}`}>
          <Card className="p-8">
            <h1 className={`${language === 'ur' ? 'text-urdu-3xl text-right' : 'text-4xl'} font-bold mb-6 text-blue-700`}>
              {language === 'ur' ? 'استعمال کی شرائط' : 'Terms of Service'}
            </h1>

            <div className="space-y-6">
              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۱. خدمات کی قبولیت' : '1. Acceptance of Services'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'عدالت بوٹ استعمال کرکے، آپ ان شرائط و ضوابط سے اتفاق کرتے ہیں۔ اگر آپ ان شرائط سے متفق نہیں ہیں تو براہ کرم یہ سروس استعمال نہ کریں۔ یہ سروس صرف معلومات اور دستاویزات کی تیاری میں مدد کے لیے ہے۔'
                    : 'By using Adalat Bot, you agree to these terms and conditions. If you do not agree to these terms, please do not use this service. This service is only for information and assistance in document preparation.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۲. قانونی مشورہ نہیں' : '2. Not Legal Advice'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'عدالت بوٹ قانونی مشورہ فراہم نہیں کرتا۔ یہ صرف ایک AI ٹول ہے جو دستاویزات کی تیاری میں مدد کرتا ہے۔ اہم قانونی معاملات میں ہمیشہ کسی مجاز وکیل سے مشورہ کریں۔ ہم کسی بھی قانونی نتیجے کے ذمہ دار نہیں ہیں۔'
                    : 'Adalat Bot does not provide legal advice. It is only an AI tool that helps in document preparation. Always consult a licensed lawyer for important legal matters. We are not responsible for any legal consequences.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۳. صارف کی ذمہ داری' : '3. User Responsibility'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'آپ ذمہ دار ہیں کہ آپ درست اور مکمل معلومات فراہم کریں۔ تیار شدہ دستاویز استعمال کرنے سے پہلے اس کا جائزہ لینا آپ کی ذمہ داری ہے۔ آپ اس بات کی تصدیق کرتے ہیں کہ آپ 18 سال یا اس سے زیادہ عمر کے ہیں۔'
                    : 'You are responsible for providing accurate and complete information. It is your responsibility to review the generated document before using it. You confirm that you are 18 years of age or older.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۴. رازداری' : '4. Privacy'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم آپ کی رازداری کا احترام کرتے ہیں۔ آپ کی ذاتی معلومات محفوظ اور خفیہ رکھی جاتی ہیں۔ ہم آپ کی معلومات کسی تیسرے فریق کے ساتھ شیئر نہیں کرتے، سوائے قانونی ضرورت کے۔'
                    : 'We respect your privacy. Your personal information is kept secure and confidential. We do not share your information with third parties, except when legally required.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۵. دانشورانہ املاک' : '5. Intellectual Property'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'عدالت بوٹ کا تمام مواد، ڈیزائن، اور فعالیت ہماری دانشورانہ املاک ہے۔ آپ تیار شدہ دستاویزات کا مالک ہیں، لیکن پلیٹ فارم کی کاپی یا تقلید نہیں کر سکتے۔'
                    : 'All content, design, and functionality of Adalat Bot is our intellectual property. You own the generated documents, but cannot copy or imitate the platform.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۶. ذمہ داری کی حد' : '6. Limitation of Liability'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'عدالت بوٹ "جیسا ہے" کی بنیاد پر فراہم کیا جاتا ہے۔ ہم کسی بھی نقصان، چاہے وہ براہ راست یا بالواسطہ ہو، کے ذمہ دار نہیں ہیں۔ اس میں ڈیٹا کا نقصان، کاروبار کا نقصان، یا قانونی مسائل شامل ہیں۔'
                    : 'Adalat Bot is provided "as is". We are not liable for any damages, whether direct or indirect. This includes data loss, business loss, or legal issues.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۷. تبدیلیاں' : '7. Changes'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم کسی بھی وقت ان شرائط میں تبدیلی کا حق محفوظ رکھتے ہیں۔ تبدیلیاں فوری طور پر نافذ ہوں گی۔ سروس کا مسلسل استعمال تبدیلیوں کی قبولیت سمجھا جائے گا۔'
                    : 'We reserve the right to change these terms at any time. Changes will be effective immediately. Continued use of the service will be considered acceptance of the changes.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۸ رابطہ' : '8. Contact'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'اگر آپ کو ان شرائط کے بارے میں کوئی سوال ہے تو براہ کرم ہم سے رابطہ کریں۔'
                    : 'If you have any questions about these terms, please contact us.'}
                </p>
              </section>

              <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                <p className={`${language === 'ur' ? 'text-urdu-sm text-right' : 'text-sm'} text-gray-600`}>
                  {language === 'ur'
                    ? 'آخری اپ ڈیٹ: جنوری 2025'
                    : 'Last Updated: January 2025'}
                </p>
              </div>
            </div>
          </Card>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Terms;